export default __webpack_public_path__ + "static/media/Marktplatz.500dc706.jpg";